import React, { Fragment } from "react";
import GenericHeader from "../../common/Header";

class HeaderLayout extends React.Component {
  state = {};
  constructor() {
    super();

    this.headerLayout = [
      {
        label: {
          value: "PO Number",
          size: "50%"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "poNumber",
          autoFocus: true,
          onBlur: "lookup",
          hotMod: false,
        },
        size: "15%"
      },
      {
        label: {
          value: "Suffix",
          size: "50%"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "suffix",
          onBlur: "lookup",
          hotMod: false
        },
        size: "calc(85% / 8)"
      },
      {
        label: {
          value: "Status",
          size: "50%"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "status"
        },
        size: "calc(85% / 8)",
        readOnly: true
      },
      {
        label: {
          value: "Origin",
          size: "auto"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "origin"
        },
        size: "calc(85% / 8)",
        readOnly: true
      },
      {
        label: {
          value: "History",
          size: "auto"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "history"
        },
        size: "calc(85% / 8)",
        readOnly: true
      },
      {
        label: {
          value: "Class",
          size: "56px"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "clase"
        },
        size: "calc(85% / 8)",
        readOnly: true
      },
      {
        label: {
          value: "Trans",
          size: "auto"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "trans"
        },
        size: "calc(85% / 8)",
        readOnly: true
      },
      {
        label: {
          value: "CRS Dock",
          size: "auto"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "crsdock"
        },
        size: "calc(85% / 8)",
        readOnly: true
      },
      {
        label: {
          value: "Inco Trms",
          size: "auto"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "incoTerms"
        },
        size: "calc(85% / 8)",
        readOnly: true
      },
      {
        label: {
          value: "Vendor",
          size: "50%"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "vend"
        },
        size: "15%",
        readOnly: true
      },
      {
        label: {
          value: "Vendor Name",
          size: "calc(100% / 7)"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "vendorName"
        },
        size: "calc(85% / 8 * 7)",
        readOnly: true
      },
      {
        label: {
          value: "Agent",
          size: "auto"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "agent"
        },
        size: "calc(85% / 8)",
        readOnly: true
      },
      {
        label: {
          value: "PO Note",
          size: "15%"
        },
        item: {
          node: "input",
          type: "string",
          value: "",
          intemName: "poNote"
        },
        size: "calc(100%)",
        readOnly: true
      }
    ];
  }
  componentDidMount() {
    this.setState({ layout: this.headerLayout });
  }

  formatData = props => {
    if (props) {
      this.headerLayout.map((layout, key) => {
        if (layout.item.intemName === props[key].name) {
          layout.item.value =
            props[key].value === undefined ||
            props[key].value === "" ||
            props[key].value === false
              ? ""
              : props[key].value;
          layout.item.obj = props[key].obj;
          layout.item.span = props[key].span;
          layout.label.value = props[key].label;
        }
        return null;
      });
    }

    return null;
  };
  getHeaderInfo = info => {
    this.props.setHeaderInfo({ header: info });
  };
  renderHeader = () => {
    this.formatData(this.props.headerData);
    return (
      <GenericHeader
        jsonObj={this.state.layout}
        setHeaderInfo={this.getHeaderInfo}
        functions={{
          lookup: this.props.lookup,
          setErrorMessage: this.props.setErrorMessage,
          setSuccessMessage: this.props.setSuccessMessage
        }}
      />
    );
  };

  getTheJson = () => {
    for (let index = 0; index < this.headerLayout.length; index++) {
   
    }
  };
  render() {
    return (
      <Fragment>
        {/* <button onClick={e => this.getTheJson()} /> */}
        {this.renderHeader()}
      </Fragment>
    );
  }
}
export default HeaderLayout;
